<template>
  <v-footer padless app>
    <v-card flat tile width="100%" class="primary text-body-1">
      <v-card-text class="text-body-1">
        <v-row>
          <v-col>
            Copyright &copy; 2008 - {{ new Date().getFullYear() }} HardinServer.com
          </v-col>
          <v-col class="text-end">
            <a href="https://www.facebook.com/HardinPCRepair/" target="_blank">
              <v-icon large>mdi-facebook</v-icon>
            </a>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-footer>
</template>


<script>
export default {
  name: 'FooterBar'
}
</script>